module.exports = __webpack_public_path__ + "media/open_box1.d2e4018d.mp3";